import { CookiesRepository } from '~/core/repositories/CookiesRepository';

export class CookiesService {
  static initialize() {
    const storedConfig = CookiesRepository.getConfig();
    if (storedConfig.allowedCategories.includes('analytics')) {
      CookiesService.loadYandexMetrika();
    }
    return storedConfig;
  }

  static setCookies(categories: string[]) {
    CookiesRepository.saveConfig({ allowedCategories: categories, cookiesAccepted: 'accepted' });
    if (!categories.includes('analytics')) this.stopAnalytics();
  }

  static rejectCookies() {
    CookiesRepository.saveConfig({ allowedCategories: [], cookiesAccepted: 'rejected' });
    this.stopAnalytics();
  }

  private static stopAnalytics() {
    // Saving consent before reloading also stops any already-running counter.
    if (document.getElementById('videosurv-metrika')) window.location.reload();
  }

  static loadYandexMetrika() {
    const id = String(useRuntimeConfig().public.metrikaId || '');
    if (!/^\d+$/.test(id) || document.getElementById('videosurv-metrika')) return;
    const script = document.createElement('script');
    script.id = 'videosurv-metrika';
    script.src = 'https://mc.yandex.ru/metrika/tag.js';
    script.async = true;
    // Queue initialization before the external script loads.
    // @ts-ignore
    window.ym =
      window.ym ||
      function () {
        // @ts-ignore
        (window.ym.a = window.ym.a || []).push(arguments);
      };
    // @ts-ignore
    window.ym.l = +new Date();
    // @ts-ignore
    window.ym(Number(id), 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
    });
    document.head.appendChild(script);
  }
}
